import { Typography } from '@mui/material';
import { fmt } from '../../utils/common';
import { DetailsRow } from '../DetailsRow';
import PartyDisplay from '../PartyDisplay';
import { StateCell, Status } from '../StateCell';
import { DetailsLayout } from './DetailsLayout';
import { RowNew } from './types';

interface DetailsProps {
  row?: RowNew;
}

export const Details: React.FC<DetailsProps> = ({ row }) => {
  if (!row) {
    return null;
  }
  const details = [
    {
      label: 'state',
      value: <StateCell state={row.requestState as Status} reason={row.reason} />,
    },
    {
      label: 'Instrument ID',
      value: row.instrumentId,
    },
    {
      label: 'amount',
      value: fmt(row.amount, 2),
    },
    {
      label: 'registrar',
      value: <PartyDisplay party={row.registrar} />,
    },
    {
      label: 'sender',
      value: <PartyDisplay party={row.sender} />,
    },
    {
      label: 'receiver',
      value: <PartyDisplay party={row.receiver} />,
    },
    {
      label: 'operator',
      value: <PartyDisplay party={row.operator} />,
    },
    {
      label: 'reference',
      value: row.reference,
    },

    {
      label: 'Created at',
      value: (
        <Typography variant="caption" fontFamily="monospace">
          {new Date(row.createdAt).toLocaleString()}
        </Typography>
      ),
    },
  ];
  if (row.executeBefore !== undefined) {
    details.splice(1, 0, {
      label: 'execute before (local time)',
      value: `${new Date(row.executeBefore).toLocaleString()}`,
    });
  }

  if (row.reason) {
    details.splice(1, 0, {
      label: 'reason',
      value: row.reason,
    });
  }
  return (
    <DetailsLayout>
      {details.map((detail) => (
        <DetailsRow key={detail.label} value={detail.value} label={detail.label} />
      ))}
    </DetailsLayout>
  );
};
